<div>
    <div class="flex justify-center items-center text-paragraphe">
        <div class="max-w-[1000px] w-full">
            
            <div class="flex flex-col gap-5">
                <h3 class="text-title">Modifier un regroupement d'expression de besoin</h3>
                <form 
                    [formGroup]="expressionBesoinForm"
                    (ngSubmit)="onSubmit()"
                    class="flex flex-col gap-5"
                >
                    <!-- Champs dynamiques pour les activités -->
                    <div class="flex flex-col">
                        <div class="bg-gray-100 p-3 flex flex-col gap-4 rounded-lg">
                            <div class="flex justify-between items-center">
                                <h4 class="text-sub-title">Expression de besoin Associées</h4>
                                <button
                                    type="button"
                                    class="button_secondary flex items-center gap-1"
                                    (click)="addActivity()"
                                >
                                    <mat-icon class="text-base">add</mat-icon>
                                    Ajouter une activité
                                </button>
                            </div>
                            
                            <!-- Conteneur pour le FormArray -->
                            <div 
                                class="w-full flex flex-col gap-3" 
                                formArrayName="activitesSelectionnees"
                            >
                                @for (control of activitesFormArray.controls; track $index) {
                                    <div class="flex items-center gap-2">
                                        <select
                                            [formControlName]="$index"
                                            class="
                                                mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md
                                                shadow-sm focus:outline-none focus:ring-indigo-500
                                                focus:border-indigo-500 bg-white
                                            "
                                        >
                                            <option value="" disabled selected>Sélectionner une activité</option>
                                            @for (activite of activities; track activite.id) {
                                                <option [value]="activite.id">{{ activite.titre }}</option>
                                            }
                                        </select>
                                        <button
                                            type="button"
                                            (click)="removeActivity($index)"
                                            class="p-2 rounded-md bg-red-500 text-white flex items-center justify-center"
                                            [disabled]="activitesFormArray.length <= 1"
                                        >
                                            <mat-icon class="text-base">delete</mat-icon>
                                        </button>
                                    </div>
                                }
                            </div>
                        </div>
                        <div>
                            @if (activitesFormArray.length > 1) {
                                <div formGroupName="complementaryInfo" class="p-3 flex flex-col gap-4 rounded-lg mt-5">
                                    <div>
                                        <h4>Informations Complémentaires</h4>
                                    </div>
                                    <div class="flex flex-col gap-5">
                                        <div class="flex flex-row gap-5">
                                            <app-input
                                                type="text"
                                                label="Libelle"
                                                formControlName="libelle"
                                                class="flex-1"
                                            />
                                            <app-input
                                                type="text"
                                                label="Description"
                                                formControlName="description"
                                                class="flex-1"
                                            />
                                        </div>
                                        <div class="flex flex-row gap-5">
                                            <app-select
                                                label="Superviseur"
                                                formControlName="supervisor"
                                                [options]="structureData"
                                                class="flex-1"
                                            />
                                            <app-select
                                                label="Structure responsable"
                                                formControlName="structureResponsable"
                                                [options]="structureData"
                                                class="flex-1"
                                            />
                                            
                                        </div>
                                        <div class="flex flex-row gap-5">
                                            <app-input 
                                                type="text" 
                                                formControlName="montantEstimatif"
                                                label="Montant estimatif"
                                                class="flex-1"
                                            />
                                            <app-select
                                                label="Imputation budgétaire"
                                                formControlName="imputationBudgetaire"
                                                [options]="ligneBudgetaires"
                                                class="flex-1"
                                            />
                                        </div>
                                        <div class="flex flex-row gap-5">
                                            <app-input 
                                                type="text" 
                                                formControlName="coutPrevuN1"
                                                label="Coût prévu N+1"
                                                class="flex-1"
                                            />
                                            <app-input 
                                                type="text" 
                                                label="Prévision de décaissement pour N+2"
                                                formControlName="previsionDecaissementN2"
                                                class="flex-1"
                                            />
                                        </div>
                                        <div class="flex flex-row gap-5 items-end">
                                            <app-input
                                                label="Date prévisionelle limite de transmission des spécifications techniques/TDR/DM"
                                                formControlName="datePrevision"
                                                type="date"
                                                class="flex-1"
                                            />
                                            <app-input
                                                label="Durée prévisionelle  d'exécution du marché (en Jour)"
                                                formControlName="dureePrevisionExecutionMarche"
                                                type="text"
                                                class="flex-1"
                                            />
                                        </div>
                                    </div>

                                </div>
                            }
                        </div>
                    </div>

                    <button
                        type="submit"
                        class="button_primary relative"
                        [disabled]="isLoading"
                    >
                        <span [class.invisible]="isLoading"> Modifier </span>
                        @if (isLoading) {
                            <div class="absolute inset-0 flex items-center justify-center">
                                <app-loader></app-loader>
                            </div>
                        }
                    </button>
                </form>
            </div>
        </div>
    </div>
</div>